import AuthService from 'common/auth/AuthService.js';

import keycloakService from './KeycloakService.js';
import * as types from './Types.js';

export function checkUserExists() {
  return ({ fetch }) => {
    const getPromise = async () => {
      AuthService.saveAuthentication(keycloakService.getToken());
      AuthService.saveRefreshToken(keycloakService.getRefreshToken());
      const { sub } = await keycloakService.getUser();
      return fetch(`/keycloak/exists/${sub}`);
    };
    return {
      type: types.CHECK_USER_KEYCLOAK_EXISTS,
      payload: getPromise().then(response => response)
    };
  };
}

export function loadUserRoles() {
  return ({ fetch }) => {
    const getPromise = async () => {
      const { sub } = await keycloakService.getUser();
      const { clientRoles: roles } = await fetch(`/keycloak/${sub}/roles`);

      return { roles };
    };

    return {
      type: types.GET_USER_ROLES,
      payload: getPromise()
    };
  };
}
